import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PedidoComponent } from "./component/pedido/pedido.component";
import { AuthGuard } from './AuthGuard/auth-guard.service'
import { SincronismoComponent } from "./component/sincronismo/sincronismo.component";
import { LoginComponent } from './component/login/login.component';
import { HomeClienteComponent } from './component/home-cliente/home-cliente.component';
import { ConsultarPedidoComponent } from './component/consultar-pedido/consultar-pedido.component';
import { CadProdutoComponent } from './component/cad-produto/cad-produto.component';
import { CadUsuarioComponent } from './component/cad-usuario/cad-usuario.component';
import { InstrucoesImportacaoComponent } from './component/instrucoes-importacao/instrucoes-importacao.component';
import { CadVendedorComponent } from './component/cad-vendedor/cad-vendedor.component';
import { LeedsComponent } from './component/leeds/leeds.component';
import { LeedsTermosComponent } from './component/leeds-termos/leeds-termos.component';
import { LeedsDistribuidorComponent } from './component/leeds-distribuidor/leeds-distribuidor.component';
import { CadRegiaoComponent } from 'src/admin-leeds/components/cad-regiao/cad-regiao.component';
import { DistribuidorComponent } from 'src/admin-leeds/components/distribuidor/distribuidor.component';
import { AdminLeedsComponent } from './component/admin-leeds/admin-leeds.component';
import { EstadoCidadeComponent } from './component/estado-cidade/estado-cidade.component';


const routes: Routes = [
  { path: '', component: HomeClienteComponent, canActivate: [AuthGuard] },
  { path: 'cadastro', component: LeedsComponent },
  { path: 'cadastro/termos', component: LeedsTermosComponent },
  { path: 'leeds-distribuidor', component: LeedsDistribuidorComponent, canActivate: [AuthGuard] },
  { path: 'pedido', component: PedidoComponent, canActivate: [AuthGuard] },
  { path: 'consulta', component: ConsultarPedidoComponent, canActivate: [AuthGuard] },
  { path: 'admin', component: SincronismoComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'produto', component: CadProdutoComponent },
  { path: 'usuario', component: CadUsuarioComponent },
  { path: 'vendedor', component: CadVendedorComponent },
  { path: 'marketing', loadChildren: '../marketing/marketing.module#MarketingModule' },
  { path: 'marketing/Leads', loadChildren: '../marketing/marketing.module#MarketingModule' },
  { path: 'integracao', component: InstrucoesImportacaoComponent },
  { path: 'regiao', component: CadRegiaoComponent },
  { path: 'distribuidor', component: DistribuidorComponent },
  { path: 'estado-cidade', component: EstadoCidadeComponent, canActivate: [AuthGuard] },
  { path: 'gerenciamento-leeds', component: AdminLeedsComponent, canActivate: [AuthGuard] }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
